import { ICommonSettings } from "@kuika/kuika-cl-model";
import { PureComponent, ReactNode } from "react";
import { ICommonConfigDeleteFunctionParams, ICommonConfigSaveFunctionParams } from "../app-settings-config-container";
import { ConfigSettingSelect } from "../config-setting-select";
import { ConfigDocumentManagementSettings } from "./app-settings-config-document-management";

export interface IConfigDocumentManagementInputState {
  showModal: boolean;
  editingId: string;
}

export interface IConfigDocumentManagementInputProps {
  parentConfigValue?: string | null;
  commonSettings: ICommonSettings;
  getSectionDescription: (contentKey: string) => ReactNode;
  handleUpdateCustomFormInput: (formItemName: string[], value: string | null) => void;
  handleCreateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleUpdateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleDeleteCommonConfig: (params: ICommonConfigDeleteFunctionParams) => void;
}

export class ConfigDocumentManagementInput extends PureComponent<
  IConfigDocumentManagementInputProps,
  IConfigDocumentManagementInputState
> {
  formInputName = ["apiConfig", "documentManagementSettingsId"];

  constructor(props: IConfigDocumentManagementInputProps) {
    super(props);
    this.state = { showModal: false, editingId: "" };
  }

  openModal = () => this.setState({ showModal: true, editingId: "" });

  closeModal = () => this.setState({ showModal: false });

  setEditing = (id: string) => {
    if (!id) return;
    this.setState({ editingId: id, showModal: true });
  };

  handleRestore = (): void => {
    this.props.handleUpdateCustomFormInput?.(this.formInputName, this.props.parentConfigValue ?? null);
  };

  render() {
    const {
      parentConfigValue,
      commonSettings,
      getSectionDescription,
      handleUpdateCustomFormInput,
      handleCreateCommonConfig,
      handleUpdateCommonConfig,
      handleDeleteCommonConfig
    } = this.props;

    const options = (commonSettings.documentManagementSettings || []).map((x) => ({ id: x.id, name: x.name }));

    return (
      <>
        <ConfigDocumentManagementSettings
          formInputName={this.formInputName}
          showModal={this.state.showModal}
          closeModal={this.closeModal}
          editingDocumentManagementId={this.state.editingId}
          commonSettings={commonSettings}
          getSectionDescription={getSectionDescription}
          handleCreateCommonConfig={handleCreateCommonConfig}
          handleUpdateCommonConfig={handleUpdateCommonConfig}
          handleDeleteCommonConfig={handleDeleteCommonConfig}
        />
        <ConfigSettingSelect
          label="Document Management"
          formInputName={this.formInputName}
          options={options}
          normalize={(val: string | null) => (val === "null" || val === "" ? null : val)}
          tooltipContentKey="appsettings_documentmanagement"
          onAddNew={this.openModal}
          onEdit={this.setEditing}
          parentConfigValue={this.props.parentConfigValue}
          onRestore={this.handleRestore}
          dropdownTestId="appSettingsDocumentManagementDropdown"
          addNewTestId="appSettingsDocumentManagementDropdownAddNew"
        />
      </>
    );
  }
}
